 export const careerData= {
    profiles: [
    {
      icon: "🎓",
      title: "Jeunes Diplômés",
      description: "Débutez votre carrière avec impact",
      details: "Formations internes, mentorat personnalisé et parcours d'intégration structuré"
    },
    {
      icon: "💼",
      title: "Profils Qualifiés",
      description: "Experts et collaborateurs expérimentés",
      details: "Missions stratégiques, autonomie et opportunités d'évolution rapide"
    },
    {
      icon: "🎯",
      title: "Stagiaires & Alternants",
      description: "Apprenez auprès des meilleurs",
      details: "Immersion professionnelle, projets concrets et développement de compétences"
    },
    {
      icon: "⭐",
      title: "Consultants Experts",
      description: "Partagez votre expertise",
      details: "Missions à forte valeur ajoutée, flexibilité et rémunération attractive"
    }
  ],
  disciplines: [
    { name: "Droit", icon: "⚖️" },
    { name: "Sciences Économiques", icon: "📊" },
    { name: "Statistiques", icon: "📈" },
    { name: "Gestion", icon: "💼" },
    { name: "Finance", icon: "💰" },
    { name: "Comptabilité", icon: "🧮" },
    { name: "Mathématiques", icon: "🔢" },
    { name: "BTP", icon: ":🏗️" }
  ],
  benefits:[
    {
      icon: "🚀",
      title: "Développement Professionnel",
      description: "Formations continues et certifications professionnelles"
    },
    {
      icon: "🤝",
      title: "Culture Collaborative",
      description: "Environnement de travail bienveillant et stimulant"
    },
    {
      icon: "💡",
      title: "Projets à Impact",
      description: "Participez à des missions qui transforment l'économie locale"
    },
    {
      icon: "📈",
      title: "Évolution Rapide",
      description: "Opportunités de promotion basées sur les performances"
    },
    {
      icon: "🌍",
      title: "Diversité des Missions",
      description: "Travaillez sur des projets variés et enrichissants"
    },
    {
      icon: "🎁",
      title: "Avantages Attractifs",
      description: "Rémunération compétitive et package social avantageux"
    }
  ],
  values: [
    {
      title: "Adaptabilité",
      description: "Capacité à s'adapter aux différents contextes et défis"
    },
    {
      title: "Excellence",
      description: "Engagement envers la qualité et le dépassement de soi"
    },
    {
      title: "Orientation Client",
      description: "Répondre aux attentes et créer de la valeur pour nos clients"
    },
    {
      title: "Innovation",
      description: "Proposer des solutions créatives et avant-gardistes"
    }
  ]
  } 


